import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, CheckCircle, TrendingUp, DollarSign, Clock } from "lucide-react";

const FBLanding = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-600 to-orange-700">
      <div className="max-w-4xl mx-auto px-4 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="w-16 h-16 bg-white rounded-xl flex items-center justify-center shadow-lg">
              <Home className="w-10 h-10 text-orange-600" />
            </div>
            <h1 className="text-4xl font-bold text-white" style={{ fontFamily: 'Playfair Display' }}>
              Its-Sold.com
            </h1>
          </div>
          <h2 className="text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display' }}>
            Tired of Facebook Marketplace?
          </h2>
          <p className="text-2xl text-orange-100 mb-8">
            List your DFW home on a <span className="font-bold text-white">real platform</span> that serious buyers actually use
          </p>
        </div>

        {/* Problem vs Solution */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border-2 border-white/20">
            <h3 className="text-2xl font-bold text-white mb-4">❌ Facebook Problems</h3>
            <ul className="space-y-3 text-orange-100">
              <li>• Posts get buried in hours</li>
              <li>• Tire kickers & scammers</li>
              <li>• Can't add detailed info</li>
              <li>• Facebook can remove anytime</li>
              <li>• No serious buyer tools</li>
            </ul>
          </div>
          <div className="bg-white rounded-2xl p-8 border-4 border-green-400 shadow-2xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">✅ Its-Sold Benefits</h3>
            <ul className="space-y-3 text-gray-700">
              <li>• <span className="font-semibold">90 days active</span> (vs hours)</li>
              <li>• <span className="font-semibold">50+ property details</span></li>
              <li>• <span className="font-semibold">AI-powered descriptions</span></li>
              <li>• <span className="font-semibold">Pre-qualified buyers</span></li>
              <li>• <span className="font-semibold">100% FREE</span> to start</li>
            </ul>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-6 mb-12">
          {[
            { icon: Clock, stat: "90 Days", label: "Free Active Time" },
            { icon: TrendingUp, stat: "50+", label: "Free Photos Included" },
            { icon: DollarSign, stat: "$0", label: "To Get Started" }
          ].map((item, idx) => {
            const Icon = item.icon;
            return (
              <div key={idx} className="bg-white rounded-2xl p-6 text-center shadow-xl">
                <Icon className="w-12 h-12 mx-auto mb-3 text-orange-600" />
                <div className="text-4xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Playfair Display' }}>
                  {item.stat}
                </div>
                <div className="text-sm text-gray-600">{item.label}</div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="bg-white rounded-3xl p-12 text-center shadow-2xl">
          <h3 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display' }}>
            Migrate from Facebook in 60 Seconds
          </h3>
          <p className="text-xl text-gray-600 mb-8">
            Copy your Facebook listing, paste it here, and our AI does the rest!
          </p>
          <Button
            onClick={() => navigate('/import')}
            className="bg-orange-600 hover:bg-orange-700 text-white text-2xl px-12 py-8 rounded-xl shadow-xl"
            data-testid="fb-landing-cta"
          >
            🚀 Import My Facebook Listing FREE
          </Button>
          <p className="text-sm text-gray-500 mt-4">No credit card required • Takes 60 seconds</p>
        </div>

        {/* Trust Badges */}
        <div className="mt-12 grid grid-cols-3 gap-4 text-center text-white">
          <div>
            <CheckCircle className="w-8 h-8 mx-auto mb-2" />
            <p className="text-sm font-semibold">AI-Enhanced</p>
          </div>
          <div>
            <CheckCircle className="w-8 h-8 mx-auto mb-2" />
            <p className="text-sm font-semibold">DFW Focused</p>
          </div>
          <div>
            <CheckCircle className="w-8 h-8 mx-auto mb-2" />
            <p className="text-sm font-semibold">Serious Buyers</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FBLanding;
